<script setup lang="ts">
import { computed } from "vue";
import AgentNavigation from "./AgentNavigation.vue";

const props = withDefaults(
  defineProps<{
    modelValue: boolean;
    isVisible: boolean;
    ariaLabel?: string;
  }>(),
  {
    ariaLabel: "AI Agent navigation",
  }
);

const emit = defineEmits<{
  "update:modelValue": [expanded: boolean];
}>();

const isExpanded = computed(() => props.modelValue);
const toggle = () => emit("update:modelValue", !isExpanded.value);

const navRegionId = "agent-sub-sidebar-nav";
</script>

<template>
  <aside
    :aria-label="ariaLabel"
    :aria-hidden="!isVisible"
    :inert="!isVisible"
    class="flex h-full flex-col overflow-hidden bg-slate-50 shadow-[inset_-1px_0_0_0_var(--color-slate-200)] will-change-[width] contain-[layout_style]">
    <nav
      :id="navRegionId"
      class="flex-1 overflow-x-hidden overflow-y-auto">
      <AgentNavigation
        :is-expanded="isExpanded"
        @toggle="toggle" />
    </nav>
  </aside>
</template>
